import { useEffect } from 'react'
import { AlertTriangle } from 'lucide-react'
import * as Sentry from '@sentry/react'
import type { FallbackProps } from 'react-error-boundary'

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <div
      className="flex min-h-[50vh] flex-col items-center justify-center gap-4 px-4 text-center"
      style={{ color: 'var(--text-primary)' }}
    >
      <AlertTriangle
        className="h-12 w-12"
        style={{ color: 'var(--text-muted)' }}
      />
      <h2 className="text-xl font-semibold">Coś poszło nie tak</h2>
      <p
        className="max-w-md text-sm"
        style={{ color: 'var(--text-muted)' }}
      >
        {error instanceof Error
          ? error.message
          : 'Wystąpił nieoczekiwany błąd. Spróbuj ponownie.'}
      </p>
      <button
        onClick={resetErrorBoundary}
        className="mt-2 rounded-md px-4 py-2 text-sm font-medium transition-colors"
        style={{
          backgroundColor: 'var(--bg-secondary)',
          color: 'var(--text-primary)',
        }}
      >
        Spróbuj ponownie
      </button>
    </div>
  )
}
